// extracted by mini-css-extract-plugin
module.exports = {"Container":"autocomplete-search-results_Container__w2MTt","Icon":"autocomplete-search-results_Icon__o9Jo2","Item":"autocomplete-search-results_Item__HaHlK"};